'use client';

import { useState } from 'react';
import { useSession } from 'next-auth/react';
import { useAuth } from '../session-auth/hooks/useAuth';
import { useOnboardingStatus } from './useOnboardingStatus';
import { useUserAppData } from '../user-app-data/useUserAppData';

export function useOnboarding() {
  const { tempPreferredName, userEmail } = useAuth();
  const { update } = useSession();
  const { isLoading, showOnboarding: shouldShowOnboarding, isOnboarded } = useOnboardingStatus();
  const [, userAppDataActions] = useUserAppData(userEmail || '');
  const [manuallyHidden, setManuallyHidden] = useState(false);

  // Show onboarding if status says we should and it's not manually hidden
  const showOnboarding = shouldShowOnboarding && !manuallyHidden && !isLoading;

  const handleOnboardingComplete = async () => {
    setManuallyHidden(true);
    // Update the session to refresh the auth state
    await update();
    // Initialize user app data from database to refresh user data
    if (userEmail) {
      await userAppDataActions.initializeUserDataFromDB(userEmail);
    }
    // Reset manual hide after a short delay to allow for session update
    setTimeout(() => setManuallyHidden(false), 1000);
  };

  return {
    showOnboarding,
    setShowOnboarding: setManuallyHidden,
    handleOnboardingComplete,
    defaultPreferredName: tempPreferredName || '',
    isOnboardingRequired: shouldShowOnboarding,
    isLoading
  };
}
